var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"terms-section"},[(_vm.privacyForm)?_c('iframe',{attrs:{"src":_vm.privacyForm,"frameborder":"0"}}):_c('div',[_vm._v("Termo de Privacidade não encontrado")])])
}
var staticRenderFns = []

export { render, staticRenderFns }